const PersistStore = require("redux-persist").persistStore;
const AuthActions = require("actions/auth");

// Keep auth info in local storage
module.exports = store => {
    PersistStore(
        store,
        {
            whitelist: ["auth"]
        },
        () => {
            // Make sure auth is consistent with backend state (ultimate source of truth)
            store.dispatch(AuthActions.validateAuth());
        }
    );
};



// WEBPACK FOOTER //
// ./src/initializers/persist.js